/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTrendWidgetConfiguration extends models.BaseCostTrendWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostTrendWidgetConfiguration>): CostTrendWidgetConfiguration {
        let obj = Object.assign(new CostTrendWidgetConfiguration(), model);
        CostTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTrendWidgetConfiguration>): CostTrendWidgetConfiguration {
        if (!model) return null;
        return CostTrendWidgetConfiguration.newInstance(<CostTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTrendWidgetConfiguration) {
        if (!obj) return;

        models.CostTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTrendWidgetConfiguration): boolean {
        if (models.BaseCostTrendWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    primaryMetric: string;

    visibleMetrics: Array<string>;

}
